<template>
	<article class="comment" :class="[{'comment-manager': item.manager == 1}, {'comment-child': item.parent_id && item.parent_id != 0}]">
		<div class="comment-header">
			<ClientOnly>
				<span class="cp-rate comment-rate fz0">
					<span v-for="i in 5" :key="i" class="icon-star-empty" :class="{'icon-star': i <= item.rate}"></span>
				</span>
			</ClientOnly>
			<span class="comment-username" :class="{'comment-username-manager': item.manager > 0}">{{ item.display_name }}</span>
			<!--<?php if (!$item['parent_id'] AND ($user_level == 8 OR $user_level == 9 OR $user_level == 10)): ?>-->
			<!-- FIXME INTEG odgovor na komentar -->
			<a v-if="item.parent_id && item.parent_id != 0" class="comment-reply" href="">{{ labels.get('comment_reply') }}</a>
			<!--<?php endif; ?>-->
			<div v-if="labels.get('comment_header_info') != 'comment_header_info'" class="comment-info cd-flyout-btn" @click="flyoutCommentsInfo()"><BaseCmsLabel code="comment_header_info" tag="span" /></div>
			<span class="comment-date">{{ formatDate(item.datetime_created) }}</span>
		</div>

		<div class="comment-message">{{ item.message }}</div>

		<ClientOnly>
			<BaseFeedbackCommentReview :comment="item" v-slot="{status, rateUp, rateDown, positiveReviews, negativeReviews}">
				<div class="comment-review" :class="{'disabled': !item.can_reviews}">
					<template v-if="!status">
						<span v-if="item.can_reviews" class="review-links review_links">
							<a class="review-btn review_up" href="javascript:void(0);" @click="rateUp">
								<span v-if="mobileBreakpoint" class="label">{{ labels.get('commentreview_up_mobile') }}</span>
								<span v-else class="label">{{ labels.get('commentreview_up') }}</span>
								<span class="review-comment-qty review_comment review-positive" :class="{'active': positiveReviews > 0}"> ({{ positiveReviews }})</span>
							</a>
							<a class="review-btn review_down" href="javascript:void(0);" @click="rateDown">
								<span v-if="mobileBreakpoint" class="label">{{ labels.get('commentreview_down_mobile') }}</span>
								<span v-else class="label">{{ labels.get('commentreview_down') }}</span>
								<span class="review-comment-qty review_comment review-negative" :class="{'active': negativeReviews > 0}"> ({{ negativeReviews }})</span>
							</a>
						</span>
						<span v-else class="review-links review_links">
							<span class="review-btn review_up">
								<span v-if="mobileBreakpoint" class="label">{{ labels.get('commentreview_up_mobile') }}</span>
								<span v-else class="label">{{ labels.get('commentreview_up') }}</span>
								<span class="review-comment-qty review_comment review-positive" :class="{'active': positiveReviews > 0}"> ({{ positiveReviews }})</span>
							</span>
							<span class="review-btn review_down">
								<span v-if="mobileBreakpoint" class="label">{{ labels.get('commentreview_down_mobile') }}</span>
								<span v-else class="label">{{ labels.get('commentreview_down') }}</span>
								<span class="review-comment-qty review_comment review-negative" :class="{'active': negativeReviews > 0}"> ({{ negativeReviews }})</span>
							</span>
						</span>
					</template>
					<span v-if="status" class="comment-review-success">{{ labels.get(status) }}</span>
				</div>
			</BaseFeedbackCommentReview>
		</ClientOnly>
	</article>
</template>

<script setup>
	const props = defineProps(['item']);
	const labels = useLabels();
	const {formatDate} = useText();
	const {mobileBreakpoint} = inject('rwd');

	//flyout comments info
	const {emit} = useEventBus();
	function flyoutCommentsInfo() {
		document.body.classList.add('flyout-page', 'cd-flyout-active');
		emit('flyoutUpdate', {'flyout_title': labels.get('comment_info_flyout_title'), 'flyout_content': labels.get('comment_info_flyout_content')});
	}
</script>

<style scoped></style>
